export default __webpack_public_path__ + "static/media/recent-trends-topics.png";